<script setup>
import {interactionTypes, travelersInteractionTypes} from "@/constants/activitiesConstants";
import {useStore} from "vue2-helpers/vuex";

defineProps(['value']);
const emit = defineEmits(['input']);

const store = useStore();
</script>

<template>
    <div class="list-interaction">
        <template v-for="(name, type) in interactionTypes">
            <a
                v-if="!store.getters.isTravelersEnterprise || type in travelersInteractionTypes"
                :key="type"
                :class="[`list-interaction__${type}`, {active: value === type}]"
                @click="emit('input', type)"
            >
                {{ store.getters.isTravelersEnterprise && type in travelersInteractionTypes ? travelersInteractionTypes[type] : name }}
            </a>
        </template>
    </div>
</template>

<style scoped>

</style>
